function getFirstDayOfYear(): string {
  const d = new Date();
  const year = d.getFullYear();

  return [year, '01', '01'].join('-');
}

export default getFirstDayOfYear;
